import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import AmbExpansionPanel from 'components/common/AmbExpansionPanel';
import { ReactComponent as EditIcon } from 'components/common/icons/edit-square.svg';

const SegmentsTable = styled.div`
  width: 100%;
  padding: 8px 0;
`;

const TableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  border-bottom: 1px solid #d6dee1;
`;

const HeaderCell = styled.div`
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #003247;
  display: flex;
  align-items: center;
  gap: 4px;

  &:first-of-type {
    flex: 1;
  }

  &:not(:first-of-type) {
    width: 120px;
    text-align: right;
  }
`;

const TableRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  border-bottom: 1px solid #f5f7f8;

  &:last-child {
    border-bottom: none;
  }
`;

const RowCell = styled.div`
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  color: #5c7c8a;

  &:first-of-type {
    flex: 1;
    font-weight: 400;
  }

  &:not(:first-of-type) {
    width: 120px;
  }
`;

const EditIconWrapper = styled.div`
  width: 16px;
  height: 16px;
  cursor: pointer;

  svg {
    width: 100%;
    height: 100%;
    fill: #5985e1;
  }
`;

const CardFooter = props => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div data-testid={`footer-${props.etaId}`}>
      <AmbExpansionPanel
        title="Segment Duration"
        expanded={expanded}
        onTogglePanel={() => setExpanded(!expanded)}
        id="SegmentDurationsPanel"
        accordionStyles={{
          expanded: `margin: 0px; background-color: #fafbfc;`,
          collapsed: `background-color: #fafbfc`,
        }}
        accordionSummaryStyles={{
          icon: `margin-top: 0px; top: 64%`,
          content: `background-color: #fafbfc;`,
        }}
        iconMarginTop="0px"
      >
        <SegmentsTable>
          <TableHeader>
            <HeaderCell>Segment</HeaderCell>
            <HeaderCell>
              Duration
              <EditIconWrapper onClick={() => props.onEditSegments()}>
                <EditIcon />
              </EditIconWrapper>
            </HeaderCell>
            <HeaderCell>ETA</HeaderCell>
          </TableHeader>
          {props.segments.map((segment, index) => (
            <TableRow key={`segment-${index}`}>
              <RowCell>{segment.stateLabel}</RowCell>
              <RowCell>{segment.minutesLabel}</RowCell>
              <RowCell>{segment.etaLabel}</RowCell>
            </TableRow>
          ))}
        </SegmentsTable>
      </AmbExpansionPanel>
    </div>
  );
};

CardFooter.propTypes = {
  segments: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  etaId: PropTypes.number,
  onEditSegments: PropTypes.func,
};

export default CardFooter;
